import React from 'react';
import {graphql} from 'gatsby';
import {
    PageContainerDPC,
    CardHorizontalContainerDPC,
    CardHorizontalDPC,
    CardElencoDPC,
    FormFiltriDPC, PrintButtonDPC
} from '@dpc-fe/shared';
import DpcPaginator from "@dpc-fe/shared/components/dpc-paginator";
import {getSlug} from "../functions/functions";
import {buildMenu} from "@dpc-fe/shared/js/shared-functions";
import moment from "moment";
import 'moment/locale/it';
import {prop} from "../functions/functions";

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.itemsPerPage = 3;
        this.filtra = this.filtra.bind(this);
        this.setPage = this.setPage.bind(this);
        this.fullData = this.props.data.allNodeCorsi.edges
            .sort((a, b) => a.node.field_data > b.node.field_data ? -1 : 1);
        this.data = [...this.fullData];
        this.state = {
            intervalloInizio: 0,
            intervalloFine: Math.min(this.itemsPerPage, this.props.data.allNodeCorsi.edges.length),
            currentPage: 1
        };
    }

    setPage(page) {
        let intervalloInizio = (this.itemsPerPage * page) - this.itemsPerPage;
        let intervalloFine = Math.min((intervalloInizio + this.itemsPerPage), this.props.data.allNodeCorsi.edges.length);
        this.setState({
            intervalloInizio,
            intervalloFine,
            currentPage: page
        });
    }

    filtra(filters) {

        this.data = this.fullData.filter(item => {
            if (filters.searchContent === "On line" && item.node.field_disponibile_streaming !== true)
                return false;
            if (filters.searchContent === "In presenza" && item.node.field_disponibile_streaming !== false)
                return false;
            if (filters.searchDateInit && moment(filters.searchDateInit, "DD/MM/YYYY").isAfter(moment(item.node.field_data_inizio), "day"))
                return false;
            if (filters.searchDateFine && moment(filters.searchDateFine, "DD/MM/YYYY").isBefore(moment(item.node.field_data_fine), "day"))
                return false;
            if (filters.searchAmbn.length)
                if (!item.node.relationships.field_ambito || !item.node.relationships.field_ambito.some(i => filters.searchAmbn.includes('' + i.drupal_internal__tid)))
                    return false;
            if (filters.searchTerr.length)
                if (!item.node.relationships.field_territorio || !filters.searchTerr.includes('' + item.node.relationships.field_territorio.drupal_internal__tid))
                    return false;
            if (filters.searchRisk.length)
                if (!item.node.relationships.field_rischio || !item.node.relationships.field_rischio.some(i => filters.searchRisk.includes('' + i.drupal_internal__tid)))
                    return false;
            if (filters.searchQuery && filters.searchQuery.trim().length)
                if ((!item.node.field_titolo_esteso || item.node.field_titolo_esteso.toLowerCase().indexOf(filters.searchQuery.toLowerCase()) < 0) && (!item.node.field_abstract || item.node.field_abstract.value.toLowerCase().indexOf(filters.searchQuery.toLowerCase()) < 0))
                    return false;
            //A questo punto ha superato tutti i filtri e verrà compreso nei risultati
            return true;
        });
        this.setPage(1);
    }

    render() {
        const language = 'it';
        const primoPianoContenuto = this.props.data.node?.relationships?.field_primo_piano_contenuto;
        const primoPianoImage = primoPianoContenuto ? (primoPianoContenuto?.relationships?.field_immagine_anteprima ? primoPianoContenuto.relationships.field_immagine_anteprima : null) : null;
        const primoPianoStreaming = this.props.data.node?.relationships?.field_primo_piano_streaming;
        return (
            <PageContainerDPC isFormazione={true} 
                menuItems={this.props.data.menu.edges}
                basePathNavbar={process.env.PORTALE_URL}
                isHomepage={true}
                domain={process.env.MINISITO_FORMAZIONE_LABEL}
                subdomainMenuItems={this.props.data.menuMinisito.edges}
                classeAggiuntivaSubnavbar={"has-header-subnavbar-mobile-social"}
                showCondividi={true}
                minisiti={prop}
                lang={language}
                title={this.props.data.node?.title}
                pageId={this.props.data.node?.drupal_internal__nid}
                immagineShare={this.props.data.node?.relationships?.field_immagine_dettaglio ? process.env.MINISITO_FORMAZIONE_URL + this.props.data.node?.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL: process.env.MINISITO_FORMAZIONE_URL + this.props.data.socialImg?.relationships?.image?.localFile?.publicURL}
                abstractShare={this.props.data.node?.body?.processed ? this.props.data.node.body.processed.replace(/<\/?[^>]+(>|$)/g, "") : ''}
                slug={process.env.MINISITO_FORMAZIONE_URL + '/'+ language}
                menuFooterItems={this.props.data.menuFooter.edges}
            >

                {this.props.data.node?.field_box_primo_piano_immagine && 
                <CardHorizontalContainerDPC titoloSezione={this.props.data.node?.field_titolo_esteso}>
                    <CardHorizontalDPC                  
                        body={this.props.data.node?.field_abstract ? this.props.data.node.field_abstract.processed : ''}
                        image={this.props.data?.node?.relationships?.field_immagine_anteprima}
                        testoIntero={true}                    
                    />
                </CardHorizontalContainerDPC> 
                }
                {(!this.props.data.node?.field_box_primo_piano_immagine && primoPianoContenuto && !this.props.data.node?.field_streaming_homepage) &&
                <CardHorizontalContainerDPC titoloSezione={'Primo piano'}>
                    <CardHorizontalDPC
                        title={primoPianoContenuto?.field_titolo_esteso}
                        body={primoPianoContenuto?.field_abstract ? primoPianoContenuto.field_abstract.processed : ''}
                        slug={getSlug('/'+language + primoPianoContenuto?.fields?.slug, process.env.MINISITO_FORMAZIONE, primoPianoContenuto?.relationships?.field_sottodominio?.name)}
                        image={primoPianoImage ? primoPianoImage : null}
                        slugText={'Leggi di più'}
                    />
                </CardHorizontalContainerDPC>}

                {(!this.props.data.node?.field_box_primo_piano_immagine && primoPianoStreaming && this.props.data.node?.field_streaming_homepage) &&
                <CardHorizontalContainerDPC titoloSezione={'Primo piano'}>
                    <CardHorizontalDPC
                        title={primoPianoStreaming.field_titolo}
                        body={primoPianoStreaming.field_testo?.value}
                        streaming={primoPianoStreaming}
                    />
                </CardHorizontalContainerDPC>}

                <section className="container article-card-simple">
                    <h2>Corsi</h2>

                    <FormFiltriDPC lang={'it'}
                        filtra={this.filtra}
                        ambiti={buildMenu(this.props.data.ambiti.edges, language, process.env.ENV)}
                        rischi={buildMenu(this.props.data.rischi.edges, language, process.env.ENV)}
                        territori={buildMenu(this.props.data.territori.edges, language, process.env.ENV)}
                        corsiFormazione={true}
                    />

                    <div className="px-custom">

                        {this.data.slice(this.state.intervalloInizio, this.state.intervalloFine)
                            .map(node => (
                                <CardElencoDPC
                                    title={node.node.field_titolo_esteso}
                                    body={node.node.field_abstract ? node.node.field_abstract.processed : ''}
                                    slug={getSlug('/'+language + node.node.fields.slug, process.env.MINISITO_FORMAZIONE, node.node.relationships.field_sottodominio.name)}
                                    categoria={node.node.field_categoria_primaria}
                                    data_creazione={node.node.field_data_inizio ? node.node.field_data_inizio: node.node.field_data}
                                />
                            ))
                        }
                        <DpcPaginator setPage={this.setPage} numItems={this.data.length}
                                      itemsPerPage={this.itemsPerPage} key={this.data.length} currentPage={this.state.currentPage}/>
                        <PrintButtonDPC/>
                    </div>
                </section>


            </PageContainerDPC>
        );
    }

}

export default Index;

export const query = graphql`
  {
    node: nodeHomepageMinisitoFormazione(field_codice_lingua: {eq: false}) {
      field_titolo_esteso
      title
      field_abstract {
        processed
      }
      fields {
          slug
      }
      field_streaming_homepage
      field_box_primo_piano_immagine
      relationships {
        field_immagine_dettaglio {
          field_alt
          field_didascalia
          field_titolo_esteso
          relationships {
            image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                  fluid(maxWidth: 1100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
          }
          }
        }
        field_immagine_anteprima {
          field_alt
          field_didascalia
          relationships {
            image: field_immagine {
              localFile {
                publicURL
                childImageSharp {
                  fluid(maxWidth: 1100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
            }
          }
        }
        field_primo_piano_contenuto {
          ...pubblicazioneFragment
          ...notiziaFragment
          ...approfondimentoFragment
          ...normativaFragment
          ...pageFragment
          ...bandoDiGaraFragment
          ...comunicatoStampaFragment
          ...corsoFragment
          ...mappaFragment
          ...timelineFragment
          ...sezioneConAnticipazioniFragment
          ...sezioneSenzaAnticipazioniFragment
          ...elencoApprofondimentiFragment
          ...elencoGlossariFragment
          ...elencoAttualitaFragment
          ...elencoPodcastFragment
          ...elencoPubblicazioniFragment
          ...elencoNormativaFragment
          ...elencoBandiEContrattiFragment
          ...elencoFotoVideoFragment
          ...homepageVolontariatoFragment
          ...homepageRelazioniFragment
          ...homepageRischiFragment
          ...homepageNazionaleFragment
          ...homepageMappeFragment
          ...homepageGiovaniFragment
          ...homepageFormazioneFragment
          ...homepageEventiFragment
          ...homepageEmergenzeFragment
          ...homepageDocsFragment
          ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
          ...homepagePortaleFragment
          ...bollettinoCriticitaFragment
          ...bollettinoVigilanzaFragment
          ...sezioneAllertaMeteoIdroFragment
          ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
        }
        field_primo_piano_streaming {
            field_testo {
              value
            }
            field_link {
              uri
              title
            }
            field_titolo
        }
      }
    }
    allNodeCorsi(filter: {field_codice_lingua: {eq: false}}, sort: {fields: created}) {
      edges {
        node {
          drupal_internal__nid
          field_data_fine
          field_data_inizio
          field_disponibile_streaming
          relationships {
            field_ambito {
              name
            }
            field_sottodominio {
              name
            }
          }
          title
          field_titolo_esteso
          field_abstract {
            processed
            value
          }
          fields{
            slug
          }
          field_categoria_primaria
          field_data
        }
      }
    }
    menu: allTaxonomyTermMenuPortale {
          edges {
            node {
              name
              weight
              relationships {
                field_link_menu {
                    ... on node__approfondimento {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__notizia {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__page {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__sezione_senza_anticipazioni {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__sezione_con_anticipazioni {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_approfondimenti {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_podcast {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_notizie_comunicati_stampa {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_glossario {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_pubblicazioni {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_normative {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_bandi_di_gara_e_contratti {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_foto_e_video {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__homepage_minisito_volontariato {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                        drupal_internal__nid
                    }
                    ... on node__homepage_minisito_rischi {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                        drupal_internal__nid
                    }
                    ... on node__homepage_minisito_ser_nazionale {
                        fields {
                                slug
                           }
                           relationships {
                                field_sottodominio {
                                    name
                                }
                           }
                           drupal_internal__nid
                    }
                    ... on node__homepage_minisito_relazioni {
                        fields {
                                slug
                           }
                           relationships {
                                field_sottodominio {
                                    name
                                }
                           }
                           drupal_internal__nid
                    }
                    ... on node__homepage_minisito_mappe {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                    ... on node__homepage_minisito_scuola_giovani {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                    ... on node__homepage_minisito_formazione {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                    ... on node__homepage_minisito_eventi {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                    ... on node__homepage_minisito_emergenze {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                    ... on node__homepage_minisito_domande {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                    ... on node__homepage_minisito_docs {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                    ... on node__homepage_minisito_pnrr {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                    ... on node__homepage_minisito_it_alert {
                       fields {
                            slug
                       }
                       relationships {
                            field_sottodominio {
                                name
                            }
                       }
                       drupal_internal__nid
                    }
                }
                parent {
                  name
                  drupal_internal__tid
                }
              }
              drupal_internal__tid
            }
          }
        },
    menuMinisito: allTaxonomyTermMenuFormazione {
      edges {
        node {
          name
          weight
          relationships {
            field_link_menu {
                ... on node__approfondimento {
                    fields {
                      slug
                    }
                    drupal_internal__nid
                }
                ... on node__notizia {
                    fields {
                      slug
                    }
                    drupal_internal__nid
                }
                ... on node__page {
                    fields {
                      slug
                    }
                    drupal_internal__nid
                }
                ... on node__sezione_senza_anticipazioni {
                    fields {
                        slug
                    }
                    drupal_internal__nid
                }
                ... on node__sezione_con_anticipazioni {
                    fields {
                        slug
                    }
                    drupal_internal__nid
                }
                ... on node__timeline {
                    fields {
                        slug
                    }
                    drupal_internal__nid
                }
                ... on node__corsi {
                    fields {
                        slug
                    }
                    drupal_internal__nid
                }
            }
            parent {
              name
              drupal_internal__tid
            }
          }
          drupal_internal__tid
        }
      }
    },
    rischi: allTaxonomyTermRischio {
      edges {
        node {
          name
          relationships {
            parent {
              name
              drupal_internal__tid
            }
          }
          drupal_internal__tid
        }
      }
    },
    territori: allTaxonomyTermTerritorio {
      edges {
        node {
          name
          relationships {
            parent {
              name
              drupal_internal__tid
            }
          }
          drupal_internal__tid
        }
      }
    },
    ambiti: allTaxonomyTermAmbito {
      edges {
        node {
          name
          relationships {
            parent {
              name
              drupal_internal__tid
            }
          }
          drupal_internal__tid
        }
      }
    },
    menuFooter: allTaxonomyTermMenuFooter {
          edges {
            node {
              name
              weight
              relationships {
                field_link_menu {
                    ... on node__approfondimento {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__page {
                        fields {
                          slug
                        }
                        drupal_internal__nid
                    }
                    ... on node__elenco_glossario {
                        fields {
                            slug
                        }
                        drupal_internal__nid
                    }
                }
              }
              drupal_internal__tid
            }
          }
        },
        socialImg: nodeImmagine(title: {eq: "Placeholder social"}){
            relationships {
                image:field_immagine {
                  localFile {
                    publicURL
                  }
                }
            }
        }
  }
`;
